export default "__VITE_ASSET__0ebc8d0b__"